export default {
  "slots": {
    "root": "relative my-5 overflow-x-auto rounded-md outline-primary/25 focus-visible:outline-3",
    "base": "w-full border-separate border-spacing-0 rounded-md"
  }
}